/* ORTTU · Early Black 2026 · shared two-phase countdown (hero + announcement bar).
   Phase 1 (main):     counts down to data-end1 (default 2026-11-07T07:59:00Z = Fri Nov 6 23:59 PT).
   Phase 2 (extended): when phase 1 hits zero, switches to data-end2 (2026-11-10T07:59:00Z = Mon Nov 9 23:59 PT).
   After phase 2: root gets [data-eb-phase="over"] (sections hide themselves if configured).
   QA only (affects the viewer's own browser): ?eb_now=2026-11-08T12:00:00Z fakes the clock. */
(function () {
  if (window.__ebCountdown) { window.__ebCountdown.scan(); return; }
  var offset = 0;
  try {
    var q = new URLSearchParams(location.search).get('eb_now');
    if (q) { var t = Date.parse(q); if (!isNaN(t)) offset = t - Date.now(); }
  } catch (e) {}
  function now() { return Date.now() + offset; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  var roots = [];
  function scan() {
    var els = document.querySelectorAll('[data-eb-countdown]');
    for (var i = 0; i < els.length; i++) if (roots.indexOf(els[i]) < 0) roots.push(els[i]);
    tick();
  }
  function render(root) {
    var e1 = Date.parse(root.getAttribute('data-end1') || '2026-11-07T07:59:00Z');
    var e2 = Date.parse(root.getAttribute('data-end2') || '2026-11-10T07:59:00Z');
    var n = now(), phase, end;
    if (n < e1) { phase = 'main'; end = e1; }
    else if (n < e2) { phase = 'extended'; end = e2; }
    else { phase = 'over'; end = n; }
    if (root.getAttribute('data-eb-phase') !== phase) root.setAttribute('data-eb-phase', phase);
    var s = Math.max(0, Math.floor((end - n) / 1000));
    var v = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
    var u = root.querySelectorAll('[data-eb-unit]');
    for (var i = 0; i < u.length; i++) {
      var k = u[i].getAttribute('data-eb-unit'), txt = pad(v[k]);
      if (u[i].textContent !== txt) u[i].textContent = txt;
    }
    /* compact text form: "dhms" -> "4d 20h 41m 09s" (also accepts legacy "dhm" / "dh") */
    var c = root.querySelectorAll('[data-eb-compact]');
    for (var j = 0; j < c.length; j++) {
      var f = c[j].getAttribute('data-eb-compact'), out;
      if (f === 'dhms') out = (v.d > 0 ? v.d + 'd ' : '') + pad(v.h) + 'h ' + pad(v.m) + 'm ' + pad(v.s) + 's';
      else if (v.d > 0) out = v.d + 'd ' + pad(v.h) + 'h' + (f === 'dhm' ? ' ' + pad(v.m) + 'm' : '');
      else out = pad(v.h) + 'h ' + pad(v.m) + 'm' + (f === 'dhm' ? ' ' + pad(v.s) + 's' : '');
      if (c[j].textContent !== out) c[j].textContent = out;
    }
  }
  function tick() { for (var i = 0; i < roots.length; i++) render(roots[i]); }
  window.__ebCountdown = { scan: scan, now: now };
  scan();
  /* tick on each real second boundary so every timer on the page changes together */
  (function loop() { tick(); setTimeout(loop, 1000 - (now() % 1000) + 5); })();
  document.addEventListener('shopify:section:load', scan);
})();
